import React from "react";
import { BrowserRouter, Route } from 'react-router-dom';
import Header from "./Header";
import Footer from './Footer';
import Home from './Component/Home/Home'
import Listing from './Component/Listing/listingApi';
import Details from "./Component/Details/details";
import PlaceOrder from "./Component/booking/placeOrder";
import ViewOrder from "./Component/booking/viewOrder";
import Login from "./Component/login/login";
import Register from "./Component/login/ragister";
const Routing = () => {
    return (
        <BrowserRouter>
            <div>
                <Route exact path="/" component={Home} />
                <Route exact path="/listing/:categoryId" component={Listing} />
                <Route exact path="/details" component={Details} />
                <Route exact path="/placeOrder/:productName" component={PlaceOrder} />
                <Route exact path="/viewOrder" component={ViewOrder} />
                <Route path="/login" component={Login} />
                <Route path="/register" component={Register} />




                <Footer />
            </div>
        </BrowserRouter>
    )
}
export default Routing;